import { render, staticRenderFns } from "./EmpresaManter.vue?vue&type=template&id=b606f452&"
import script from "./EmpresaManter.vue?vue&type=script&lang=js&"
export * from "./EmpresaManter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports